import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import ProductsPage from '../pages/products/page';
import ProductDetailPage from '../pages/product-detail/page';
import AboutPage from '../pages/about/page';
import WhereToBuyPage from '../pages/where-to-buy/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/products',
    element: <ProductsPage />,
  },
  {
    path: '/products/:id',
    element: <ProductDetailPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/where-to-buy',
    element: <WhereToBuyPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
